const STORAGE_KEY = "steffi.adminOrganizationId";
// Light organization: the admin's frontend-only demo mode, carried into the organization view.
const LIGHT_KEY = "steffi.adminLightOrganization";
const getOrganizationId = () => window.sessionStorage.getItem(STORAGE_KEY) || "";

export function isAdminOrganizationView() {
  return Boolean(getOrganizationId());
}

export function isLightOrganizationView() {
  return isAdminOrganizationView() && window.sessionStorage.getItem(LIGHT_KEY) === "1";
}

export function clearAdminOrganizationView() {
  window.sessionStorage.removeItem(STORAGE_KEY);
  window.sessionStorage.removeItem(LIGHT_KEY);
}

export function initializeAdminOrganizationView() {
  const params = new URLSearchParams(window.location.search);
  const requestedId = params.get("admin_organization_id");
  if (requestedId) {
    window.sessionStorage.setItem(STORAGE_KEY, requestedId);
    if (params.get("light") === "1") window.sessionStorage.setItem(LIGHT_KEY, "1");
    else window.sessionStorage.removeItem(LIGHT_KEY);
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = (url, options = {}) => {
    const organizationId = getOrganizationId();
    if (!organizationId || !String(url).startsWith(process.env.REACT_APP_API_URL)) {
      return originalFetch(url, options);
    }
    return originalFetch(url, {
      ...options,
      headers: { ...options.headers, "X-Steffi-Organization-Id": organizationId },
    });
  };
}
